import React from 'react';
import { Paper, Typography, LinearProgress } from '@mui/material';
import { trakrefFontFamily } from '../../../utils';
import { Grey1, trakrefBlue } from '../../../color_utils';

const MetricCard = ({ label, value, loading, labelSx, valueSx }) => (
    <Paper
        variant="outlined"
        sx={{
            p: 2,
            height: '75%',
            display: 'flex',
            flexDirection: 'column',
            borderColor: '#E3E8EB',
            borderRadius: 2,
            position: 'relative',
            overflow: 'hidden',
        }}
    >
        {loading && (
            <LinearProgress
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    '& .MuiLinearProgress-bar': {
                        backgroundColor: trakrefBlue,
                    },
                }}
            />
        )}
        <Typography
            variant="caption"
            sx={{
                color: Grey1,
                fontFamily: trakrefFontFamily,
                fontWeight: 500,
                display: 'block',
                mb: 0.5,
                ...labelSx,
            }}
        >
            {label}
        </Typography>
        <Typography
            variant="h5"
            sx={{
                mt: 'auto',
                fontFamily: trakrefFontFamily,
                fontWeight: 400,
                ...valueSx,
            }}
        >
            {value}
        </Typography>
    </Paper>
);

export default MetricCard;
